/* =========================================================
   fj-swym-wishlist.js
   Mounts Swym's wishlist UI into our own page section.
   Swym renders the grid, cards and empty state; the theme
   owns everything around it.
   ========================================================= */

/* ---------- wishlist page mount ---------- */

(() => {
  const CONTAINER_ID = 'swym-wishlist-render-container';

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((swat) => {
    const container = document.getElementById(CONTAINER_ID);
    if (!container || container.children.length) return;

    const queryParams = swat.utils.getEncodedAsObject(window.location.search);
    swat.ui.renderWishlistInContainer(container, queryParams);
  });
})();

/* ==================== END OF fj-swym-wishlist.js ==================== */